/// <reference types="vite-plugin-svgr/client" />
import { Box, Container, Grid, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

import Logo from '~/assets/images/logo-black.svg?react';
import Fallback from '~/assets/images/fallback.svg?react';
import { FallbackMessage } from '../../../FallbackMessage';

export default function FallbackElement() {
  return (
    <Box sx={{ backgroundColor: 'background.default' }}>
      <Grid container sx={{ minHeight: '100vh' }}>
        <Grid item xs={6}>
          <Box
            sx={{
              maxWidth: {
                xs: 350,
                lg: 400,
              },
              minHeight: '100vh',
              display: 'grid',
              alignItems: 'space-between',
              py: 3.75,
              m: 'auto',
            }}>
            {/* Logo */}
            <MuiLink component={Link} to="/" sx={{ width: 116, display: 'inline-block' }}>
              <Logo />
            </MuiLink>

            {/* <>dddd</> */}

            <FallbackMessage />
          </Box>
        </Grid>
        {/* /Login form wrapper */}

        {/* Login image */}
        <Grid item xs={6}>
          <Box
            sx={{
              height: '100vh',
              backgroundColor: '#F6F7FB',
              //   backgroundImage: `url(${BackgroundImage})`,
              backgroundSize: 'cover',
            }}>
            <Container
              sx={{
                maxWidth: { xs: 380 },
                px: { xs: 0 },
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                backgroundColor: 'rgba(0, 0, 0, 0)',
              }}>
              <Fallback />
            </Container>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
